export const INTERNAL_ROLES = {
  GOD: 'GOD'
} as const;

export const INTERNAL_ALLOWED_ROLES = Object.values(INTERNAL_ROLES);
